(function () {
  'use strict';

  var MAX_FILES = 5;
  var MAX_FILE_SIZE = 25 * 1024 * 1024;
  var MAX_TOTAL_SIZE = 100 * 1024 * 1024;

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
  }

  function initQuoteRequest(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var sectionId = root.dataset.sectionId;
    var workerUrl = (root.dataset.workerUrl || '').replace(/\/+$/, '');
    var uploadWorkerUrl = (root.dataset.uploadWorkerUrl || workerUrl).replace(/\/+$/, '');
    var siteKey = root.dataset.siteKey || '';
    var submitButton = document.getElementById('BroderieQuoteSubmit-' + sectionId);
    var statusBox = document.getElementById('BroderieQuoteStatus-' + sectionId);
    var turnstileContainer = document.getElementById('BroderieQuoteTurnstile-' + sectionId);
    var filesInput = document.getElementById('BroderieQuoteFiles-' + sectionId);
    var filesSelected = document.getElementById('BroderieQuoteFilesSelected-' + sectionId);
    var submitLabel = root.dataset.submitLabel || 'Send quote request';
    var portwestMinimum = Number(root.dataset.portwestMinimum || 10);
    var isEnglish = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var portwestProductIds = [];

    try {
      portwestProductIds = JSON.parse(root.dataset.portwestProductIds || '[]').map(Number);
    } catch (error) {
      portwestProductIds = [];
    }

    var turnstileWidgetId = null;
    var turnstileToken = '';
    function field(name) { return document.getElementById('BroderieQuote' + name + '-' + sectionId); }
    function setStatus(message, type) {
      statusBox.textContent = message || '';
      statusBox.className = 'broderie-quote__status' + (message ? ' is-visible' : '') + (type ? ' is-' + type : '');
    }
    function validPhone(value) { return /^[+0-9][0-9\s().-]{7,19}$/.test(value.trim()); }
    function formatBytes(bytes) {
      if (!bytes) return '0 KB';
      var units = ['B', 'KB', 'MB', 'GB'];
      var index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
      return (bytes / Math.pow(1024, index)).toFixed(index ? 1 : 0) + ' ' + units[index];
    }
    function selectedFiles() { return filesInput && filesInput.files ? Array.prototype.slice.call(filesInput.files) : []; }
    function validateFiles(files) {
      if (files.length > MAX_FILES) throw new Error(isEnglish ? 'You may upload up to 5 files.' : 'Poți încărca maximum 5 fișiere.');
      var total = 0;
      files.forEach(function (file) {
        if (!file.size) throw new Error(isEnglish ? 'The file “' + file.name + '” is empty.' : 'Fișierul „' + file.name + '” este gol.');
        if (file.size > MAX_FILE_SIZE) throw new Error(isEnglish ? 'The file “' + file.name + '” exceeds the 25 MB limit.' : 'Fișierul „' + file.name + '” depășește limita de 25 MB.');
        total += file.size;
      });
      if (total > MAX_TOTAL_SIZE) throw new Error(isEnglish ? 'The files exceed the total limit of 100 MB.' : 'Fișierele depășesc limita totală de 100 MB.');
    }
    function renderFiles() {
      var files = selectedFiles();
      if (!filesSelected) return;
      if (!files.length) { filesSelected.hidden = true; filesSelected.innerHTML = ''; return; }
      try { validateFiles(files); }
      catch (error) { setStatus(error.message, 'error'); }
      filesSelected.innerHTML = '<strong>' + (isEnglish ? 'Selected files:' : 'Fișiere selectate:') + '</strong><ul>' + files.map(function (file) {
        return '<li>' + escapeHtml(file.name) + ' (' + formatBytes(file.size) + ')</li>';
      }).join('') + '</ul>';
      filesSelected.hidden = false;
    }
    function loadTurnstile() {
      function render() {
        if (!window.turnstile || turnstileWidgetId !== null || !turnstileContainer) return;
        turnstileWidgetId = window.turnstile.render(turnstileContainer, {
          sitekey: siteKey,
          language: isEnglish ? 'en' : 'ro',
          callback: function (token) { turnstileToken = token; },
          'expired-callback': function () { turnstileToken = ''; },
          'error-callback': function () { turnstileToken = ''; setStatus(isEnglish ? 'The security check could not be loaded. Reload the page.' : 'Verificarea de securitate nu a putut fi încărcată. Reîncarcă pagina.', 'error'); }
        });
      }
      if (window.turnstile) return render();
      var existing = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
      if (existing) { existing.addEventListener('load', render, { once: true }); return; }
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true; script.defer = true;
      script.addEventListener('load', render, { once: true });
      document.head.appendChild(script);
    }
    async function fetchCart() {
      var response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Coșul nu a putut fi citit.');
      return response.json();
    }
    function getPortwestQuantity(cart) {
      if (!cart || !Array.isArray(cart.items) || !portwestProductIds.length) return 0;

      return cart.items.reduce(function (total, item) {
        var isPortwest = portwestProductIds.indexOf(Number(item.product_id)) !== -1;
        return total + (isPortwest ? Number(item.quantity || 0) : 0);
      }, 0);
    }

    function validatePortwestMinimum(cart) {
      var quantity = getPortwestQuantity(cart);

      if (quantity > 0 && quantity < portwestMinimum) {
        var remaining = portwestMinimum - quantity;

        throw new Error(
          isEnglish
            ? 'Portwest products require a minimum combined order of ' +
              portwestMinimum +
              ' items. You can combine any products from this collection. Add ' +
              remaining +
              (remaining === 1 ? ' more Portwest product.' : ' more Portwest products.')
            : 'Produsele Portwest se livreaza incepand de la o comanda minima de ' +
              portwestMinimum +
              ' bucati. Poti combina orice produse din aceasta colectie. Mai trebuie sa adaugi ' +
              remaining +
              (remaining === 1 ? ' produs Portwest.' : ' produse Portwest.')
        );
      }
    }

    async function clearCart() {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' });
    }
    async function createSession() {
      var response = await fetch(uploadWorkerUrl + '/session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ turnstileToken: turnstileToken })
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || !data.success || !data.sessionToken) throw new Error(data.error || 'Nu s-a putut crea sesiunea securizată de upload.');
      return data.sessionToken;
    }
    async function uploadOne(file, sessionToken) {
      var response = await fetch(uploadWorkerUrl + '/upload', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + sessionToken,
          'Content-Type': file.type || 'application/octet-stream',
          'X-File-Name': encodeURIComponent(file.name),
          'X-File-Type': file.type || 'application/octet-stream'
        },
        body: file
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || !data.success || !data.file) throw new Error(data.error || 'Fișierul „' + file.name + '” nu a putut fi încărcat.');
      return data.file;
    }
    async function submitQuote() {
      setStatus('');
      var name = field('Name').value.trim();
      var email = field('Email').value.trim();
      var phone = field('Phone').value.trim();
      var preferredContactInput = root.querySelector('input[name="BroderieQuoteContact-' + sectionId + '"]:checked');
      var preferredContact = preferredContactInput ? preferredContactInput.value : 'WhatsApp';
      var message = field('Message').value.trim();
      var consent = field('Consent').checked;
      var files = selectedFiles();

      if (!name || !email || !phone) return setStatus('Completează numele, adresa de e-mail și numărul de telefon.', 'error');
      if (!field('Email').checkValidity()) return setStatus('Introdu o adresă de e-mail validă.', 'error');
      if (!validPhone(phone)) return setStatus('Introdu un număr de telefon valid.', 'error');
      if (!consent) return setStatus('Bifează acordul pentru a putea fi contactat.', 'error');
      if (!turnstileToken) return setStatus('Finalizează verificarea de securitate.', 'error');
      if (!workerUrl) return setStatus('Adresa serviciului de cereri nu este configurată.', 'error');
      try { validateFiles(files); } catch (error) { return setStatus(error.message, 'error'); }

      submitButton.disabled = true;
      submitButton.textContent = files.length ? 'Se încarcă fișierele…' : 'Se trimite cererea…';

      try {
        var cart = await fetchCart();
        if (!cart.items || cart.items.length === 0) throw new Error((isEnglish ? 'Your cart is empty.' : 'Coșul este gol.'));
        validatePortwestMinimum(cart);

        var uploadSession = await createSession();
        var uploadedFiles = [];
        for (var i = 0; i < files.length; i += 1) {
          submitButton.textContent = 'Se încarcă fișierul ' + (i + 1) + ' din ' + files.length + '…';
          uploadedFiles.push(await uploadOne(files[i], uploadSession));
        }

        submitButton.textContent = 'Se trimite cererea…';
        var payload = {
          customer: { name: name, email: email, phone: phone, preferredContact: preferredContact },
          message: message,
          consent: true,
          uploadSession: uploadSession,
          files: uploadedFiles,
          clientRequestId: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()),
          shopCurrency: cart.currency,
          cartNote: cart.note || '',
          cartTotal: cart.total_price,
          items: cart.items.map(function (item) {
            return {
              variantId: item.variant_id,
              productId: item.product_id,
              title: item.product_title,
              variantTitle: item.variant_title || '',
              quantity: item.quantity,
              price: item.final_price,
              linePrice: item.final_line_price,
              sku: item.sku || '',
              url: item.url || '',
              image: item.image || '',
              properties: item.properties || {}
            };
          })
        };
        var response = await fetch(workerUrl + '/quote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await response.json().catch(function () { return {}; });
        if (!response.ok || !data.success) throw new Error(data.error || 'Cererea nu a putut fi trimisă.');


        await clearCart();
        try {
          sessionStorage.setItem('broderieQuoteSuccess', JSON.stringify({
            quoteNumber: data.quoteNumber || '—',
            createdAt: Date.now()
          }));
        } catch (storageError) {}
        root.innerHTML = '<div class="broderie-quote__status is-visible is-success"><strong>Cererea a fost trimisă.</strong><br>Număr cerere: ' + (data.quoteNumber || '—') + '. Verifică e-mailul pentru confirmare. Pagina se actualizează automat…</div>';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.setTimeout(function () { window.location.reload(); }, 700);
      } catch (error) {
        setStatus(error.message || 'A apărut o eroare. Încearcă din nou.', 'error');
        submitButton.disabled = false;
        submitButton.textContent = submitLabel;
        turnstileToken = '';
        if (window.turnstile && turnstileWidgetId !== null) window.turnstile.reset(turnstileWidgetId);
      }
    }
    if (filesInput) filesInput.addEventListener('change', renderFiles);
    submitButton.addEventListener('click', submitQuote);
    loadTurnstile();
  }

  function showSuccessAfterReload() {
    var raw = null;
    try { raw = sessionStorage.getItem('broderieQuoteSuccess'); } catch (error) {}
    if (!raw) return;
    var data = {};
    try { data = JSON.parse(raw) || {}; } catch (error) {}
    try { sessionStorage.removeItem('broderieQuoteSuccess'); } catch (error) {}
    if (data.createdAt && Date.now() - Number(data.createdAt) > 5 * 60 * 1000) return;


    var banner = document.createElement('div');
    banner.className = 'broderie-quote__status is-visible is-success';
    banner.style.maxWidth = '1200px';
    banner.style.margin = '24px auto';
    banner.style.padding = '18px 22px';
    banner.innerHTML = '<strong>Cererea a fost trimisă.</strong><br>Număr cerere: ' + escapeHtml(data.quoteNumber || '—') + '. Verifică e-mailul pentru confirmare. Te vom contacta pentru finalizarea comenzii.';

    var main = document.querySelector('main, .page__content, .container');
    if (main) main.insertBefore(banner, main.firstChild);
    else document.body.insertBefore(banner, document.body.firstChild);
  }

  function initAll() {
    showSuccessAfterReload();
    document.querySelectorAll('.broderie-quote').forEach(initQuoteRequest);
  }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();
